import { useNavigate, useParams } from "react-router-dom";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { PageHeader, Card, Button, FormGroup } from "@cofano/cck";
import { CircularProgress, Grid } from "@mui/material";

import Helmet from "components/helmet/Helmet";
import ContainerTable from "view/containers/Containers";
import { Language } from "imports/Utils";

import { RelationLink } from "utils/LinkUtils";

import { GetSpotSalesCharterDocument } from "__generated__/view/charters/graphql/charter.queries.generated";

const SpotSalesCharter = () => {

	const navigate = useNavigate();
	const { id } = useParams();

	const { data, loading } = useQuery(GetSpotSalesCharterDocument, {
		variables: {
			id: Number(id),
		},
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("SPOT_SALES_CHARTER")}
					<Helmet title={intl.formatMessage({ id: "SPOT_SALES_CHARTER" })} />
				</PageHeader.Title>

				<PageHeader.Actions>
					<Button onClick={() => navigate("/view/spotsalescharters")}>
						{intl.formatMessage({ id: "SPOT_SALES_CHARTERS" })}
					</Button>
				</PageHeader.Actions>
			</PageHeader>

			<div style={{ marginBottom: 16 }}>
				<Card>
					{(loading || !data?.salesCharter) ? (
						<CircularProgress size={24} />
					) : (
						<Grid spacing={3} container>
							<Grid
								xs={12}
								md={12}
								lg={3}
								item>
								<FormGroup label={Language("INVOICE_CREDITOR")} overflow="hidden">
									<RelationLink relation={data?.salesCharter.creditor} />
								</FormGroup>
							</Grid>

							<Grid
								xs={12}
								md={12}
								lg={3}
								item>
								<FormGroup label={Language("INVOICE_DEBTOR")} overflow="hidden">
									<RelationLink relation={data?.salesCharter.debtor} />
								</FormGroup>
							</Grid>

							<Grid
								xs={12}
								md={12}
								lg={3}
								item>
								<FormGroup label={Language("CHARTER_ORDER_NUMBER")} overflow="hidden">
									{data?.salesCharter.charterNumber || "-"}
								</FormGroup>
							</Grid>
						</Grid>
					)}
				</Card>
			</div>

			{data?.salesCharter ? (
				<ContainerTable
					disableHeader={true}
					fixedFilters={[ { property: "charterNumber", value: data?.salesCharter.charterNumber } ]} />
			) : null}
		</div>
	);
};

export default SpotSalesCharter;
